<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="editDeviceForm">
		<div class="grid">
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="device-edit-input-name"
							formControlName="name" autocomplete="device-name" placeholder="{{ 'NAME' | translate }}"
							maxlength="48" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
				<p-button *ngIf="!this.onExtendedMobile()" pTooltip="{{ 'SAVE' | translate }}" tooltipPosition="bottom"
					icon="pi cm-check" styleClass="p-1 border-primary font-bold" [rounded]="false" [text]="true"
					severity="primary" (click)="saveName()" [disabled]="!this.f.name.dirty">
				</p-button>
				<p-button *ngIf="this.onExtendedMobile()" icon="pi cm-check" [rounded]="false" [text]="true" class="mt-3"
					severity="primary" label="{{ 'SAVE' | translate }}" (click)="saveName()"
					styleClass="border-primary font-semibold" [disabled]="!this.f.name.dirty">
				</p-button>
			</div>
			<div class="col-12" *ngFor="let fea of featureListShow">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f[fea.Id], 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f[fea.Id], 'label')">{{ translate(fea.Name) | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f[fea.Id], 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" [formControlName]="fea.Id"
							autocomplete="device-name" placeholder="{{ translate(fea.Name) | translate }}" maxlength="48" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f[fea.Id])" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
				<p-button *ngIf="!this.onExtendedMobile()" pTooltip="{{ 'SAVE' | translate }}" tooltipPosition="bottom"
					icon="pi cm-check" styleClass="p-1 border-primary font-bold" [rounded]="false" [text]="true"
					severity="primary" (click)="saveFea(fea)" [disabled]="!this.f[fea.Id].dirty">
				</p-button>
				<p-button *ngIf="this.onExtendedMobile()" icon="pi cm-check" [rounded]="false" [text]="true" class="mt-3"
					severity="primary" label="{{ 'SAVE' | translate }}" (click)="saveFea(fea)"
					styleClass="border-primary font-semibold" [disabled]="!this.f[fea.Id].dirty">
				</p-button>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<!--<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>-->
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>